/**
 * /app/columns — list of saved column designs.
 * Thin wrapper over the shared `DesignsList` configured for the
 * "columns" module slug.
 */

import { Columns3 } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function ColumnsIndexPage() {
  return (
    <DesignsList
      module="columns"
      description="Diseño de columnas según E.060 + ACI 318-19 — abre uno guardado o crea uno nuevo."
      icon={<Columns3 size={24} strokeWidth={1.5} />}
    />
  );
}
